const Delaunay = require('./../delaunay/script');

class FragmentBackground {

    constructor(el) {

        this.$el = el;
        this.$window = $(window);

        this.dimension = {
            width: 0,
            height: 0
        };

        this.size = {
            width: 532,
            height: 266
        };

        this.rendere;
        this.scene;
        this.lights = {};
        this.camera;
        this.mesh = {};

        this.gradient;
        this.grid;

        this.points = [];
        this.fragments = [];
        this.map = {};

        this.changed = false;

        this.parseGradient(el.data('gradient'));
        this.parseGrid(el.data('grid'));

        this.measure();

        this.setScene();
        this.addLights();
        this.addCamera();

        this.addBackground(el.data('background-image')).then(() => {
            this.addPolygonGrid(25, this.mesh.background ? true : false);
            this.addPolygonGrid(75);
            this.render();
        });

        this.addEventListeners();

    }

    loadTexture(url) {
        return new Promise((resolve, reject) => {
            let texture = new THREE.TextureLoader();
            texture.load(url, resolve);
        });
    }

    generatePoints() {
        let points = [];
        let column = this.size.width / this.grid[0],
            row = this.size.height / this.grid[1];
        for (let c = 0; c <= this.grid[0]; ++c) {
            for (let r = 0; r <= this.grid[1]; ++r) {
                let x = c * column + (Math.random() * column - column * .5),
                    y = r * row + (Math.random() * row - row * .5);
                points.push([Math.floor(x), Math.floor(y)]);
            }
        }
        return points;
    }

    parseGradient(gradient) {
        let gd = gradient.split('-');
        this.gradient = {
            degree: gd[0],
            colors: [gd[1].split(','), gd[2].split(',')]
        };
    }

    parseGrid(grid) {
        this.grid = grid.split(',');
    }

    measure() {
        this.dimension = {
            width: this.$el.width(),
            height: this.$el.height()
        };
    }

    resize() {
    	if(window.SETTINGS.breakpoint.minWidth('screen-medium')){
    		this.$el.removeClass('display-none');
	        this.renderer.setSize(this.dimension.width, this.dimension.height);
	        this.camera.aspect = this.dimension.width / this.dimension.height;
	        this.camera.updateProjectionMatrix();
    	}
    	else {
    		this.$el.addClass('display-none');
    	}
    }

    setScene() {
        this.scene = new THREE.Scene();
        this.renderer = new THREE.WebGLRenderer({alpha: true, antialias: true});
        this.renderer.setSize(this.dimension.width, this.dimension.height);
        this.$el.append(this.renderer.domElement);
    }

    addLights() {
        this.lights.ambient = new THREE.AmbientLight(0xFFFFFF);
        this.lights.spotlight = new THREE.SpotLight(0x666666, .5, 0, Math.PI / 3, 1);
        this.lights.spotlight.position.z = 1000;
        this.scene.add(this.lights.ambient);
        this.scene.add(this.lights.spotlight);
    }

    addCamera() {
        this.camera = new THREE.PerspectiveCamera(25, this.dimension.width / this.dimension.height, 1, 10000);
        this.camera.position.z = 500;
        this.scene.add(this.camera);
    }

    addBackground(background) {
        return new Promise((resolve, reject) => {
            if (background) {
                this.loadTexture(background).then((texture) => {
                    let geometry = new THREE.PlaneGeometry(this.size.width, this.size.height),
                        material = new THREE.MeshBasicMaterial({map: texture});
                    this.mesh.background = new THREE.Mesh(geometry, material);
                    this.scene.add(this.mesh.background);
                    resolve();
                });
            } else {
                resolve();
            }
        });
    }

    // TODO! separate functionality
    addPolygonGrid(margin, multiply) {
        let points = this.generatePoints(),
            triangles = Delaunay.triangulate(points);

        for (let i = triangles.length; i;) {

            let geometry = new THREE.Geometry();

            let position = [0, 0],
                hash = [];

            for (let ii = 0; ii < 3; ++ii) {
                --i;
                geometry.vertices.push(new THREE.Vector3(points[triangles[i]][0] - this.size.width * .5, points[triangles[i]][1] - this.size.height * .5, 0));
                position[0] += points[triangles[i]][0];
                position[1] += points[triangles[i]][1];
                hash.push({
                    id: points[triangles[i]][0] + '-' + points[triangles[i]][1],
                    point: ii
                });
            }

            geometry.faces.push(new THREE.Face3(0, 1, 2));
            geometry.dynamic = true;
            geometry.computeFaceNormals();
            geometry.computeVertexNormals();

            position[0] /= 3;
            position[1] /= 3;

            let level = [
                position[0] / this.size.width,
                position[1] / this.size.height
            ];

            let color = (level[1] + (level[0] * (this.gradient.degree / 90))) / (1 + this.gradient.degree / 90);

            let rgb = [
                Math.round(this.gradient.colors[0][0] - ((this.gradient.colors[0][0] - this.gradient.colors[1][0]) * color)),
                Math.round(this.gradient.colors[0][1] - ((this.gradient.colors[0][1] - this.gradient.colors[1][1]) * color)),
                Math.round(this.gradient.colors[0][2] - ((this.gradient.colors[0][2] - this.gradient.colors[1][2]) * color))
            ];

            let material = new THREE.MeshPhongMaterial({
                color: `rgb(${rgb[0]}, ${rgb[1]}, ${rgb[2]})`,
                specular: 0x25c4f6,
                shading: THREE.FlatShading,
                side: THREE.DoubleSide,
                blending: multiply ? THREE.MultiplyBlending : false,
                shininess: 100,
                transparent: true,
                opacity: Math.random() * 0.10 + 0.05
            });

            let mesh = new THREE.Mesh(geometry, material);
            mesh.position.z = margin;

            this.fragments.push({
                mesh,
                points: [
                    {z: [0, 0]},
                    {z: [0, 0]},
                    {z: [0, 0]}
                ]
            });

            for (let h of hash) {
                if (!this.map[h.id]) this.map[h.id] = [];
                this.map[h.id].push({
                    fragment: this.fragments.length - 1,
                    point: h.point
                });
            }

            this.scene.add(mesh);
        }

        for (let p of points) this.points.push(p);
    }

    update() {
        for (let p of this.points) {
            let value = Math.random() * 50 - 25;
            for (let m of this.map[p[0] + '-' + p[1]]) {
                let difference = this.fragments[m.fragment].points[m.point].z[1] - this.fragments[m.fragment].points[m.point].z[0];
                if (Math.abs(difference) < 1) this.fragments[m.fragment].points[m.point].z[1] = value;
                this.fragments[m.fragment].points[m.point].z[0] += difference * .0075;
                this.fragments[m.fragment].mesh.geometry.vertices[m.point].z = this.fragments[m.fragment].points[m.point].z[0];
                this.fragments[m.fragment].mesh.geometry.verticesNeedUpdate = true;
            }
        }
        this.changed = true;
    }

    render() {
        this.update();
        this.renderer.render(this.scene, this.camera);
    }

    destroy() {
        this.$el.remove();
        this.removeEventListeners();
    }

    windowOnResize() {
        this.measure();
        this.resize();
    }

    addEventListeners() {
        window.vent.on('windowResize', this.resize, this);
    }

    removeEventListeners() {
        window.vent.off('windowResize', this.resize, this);
    }

}

module.exports = FragmentBackground;
